
import { useLoaderStore } from '../../Services/LoaderService'
import Loader from './Loader'


export const GlobalLoader = () => {
  const { isLoading } = useLoaderStore()
  return <Loader isLoading={isLoading}  size={'large'}/>
} 